import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, useHistory, useLocation } from 'react-router-dom'
import { StringParam } from 'use-query-params'
import { useMarketplaceContext } from 'utils/context/MarketplaceContext'
import { fetchLoadDetails } from 'apps/fleet-planner/utils/actions/loadDetails'
import { loadDetailsSelector } from 'apps/fleet-planner/utils/selectors'
import { useQueryParams } from 'utils/hooks'
import { CheckinCheckOutTimesModal } from '../../components/load-details/CheckinCheckoutTimesModal'
import { PickupEtaModal } from '../../components/load-details/PickupEtaModal'

export const LoadsStatusUpdatesContainer = () => {
  const [{ loadId }] = useQueryParams({
    loadId: StringParam,
  })
  const { load } = useSelector(loadDetailsSelector)
  const { pathname = '' } = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const { getMarketplaceLoad, shipmentDetails } = useMarketplaceContext()
  const { id } = shipmentDetails || {}
  const { externalId, isExternal } = load || {}

  // Fetch load details and update store if loadId queryParam is present
  useEffect(() => {
    if (loadId) {
      dispatch(fetchLoadDetails(loadId))
    }
  }, [dispatch, loadId])

  // Fetch marketplace details if load is external
  useEffect(() => {
    if (isExternal && externalId) {
      getMarketplaceLoad(externalId)
    }
  }, [externalId, getMarketplaceLoad, isExternal])

  const closeCheckinCheckoutTimesModalHandler = () => {
    history.push(pathname.replace(/(\/update-status)/, ''))
  }

  const closePickupEtaModalHandler = () => {
    history.push(pathname.replace(/(\/update-eta)/, ''))
  }

  return (
    <>
      <Route exact path='/loads/update-status'>
        {id && (
          <CheckinCheckOutTimesModal
            load={load}
            isOpen
            onClose={closeCheckinCheckoutTimesModalHandler}
          />
        )}
      </Route>
      <Route exact path='/loads/update-eta'>
        <PickupEtaModal load={load} isOpen onClose={closePickupEtaModalHandler} />
      </Route>
    </>
  )
}
